import glpAppUniversal from '@/modules/Landing/instances/areas/glp-app/index'
import glpAppUniversalPromo from '@/modules/Landing/instances/areas/glp-app/promo/index'
import glpAppSemaglutidePromo from '@/modules/Landing/instances/areas/glp-app/promo/semaglutide'
import glpAppTirzepatidePromo from '@/modules/Landing/instances/areas/glp-app/promo/tirzepatide'
import glpAppSemaglutide from '@/modules/Landing/instances/areas/glp-app/semaglutide'
import glpAppTirzepatide from '@/modules/Landing/instances/areas/glp-app/tirzepatide'
import glpAppV2Universal from '@/modules/Landing/instances/areas/glp-app-v2/index'
import glpAppV2Semaglutide from '@/modules/Landing/instances/areas/glp-app-v2/semaglutide'
import glpAppV2Tirzepatide from '@/modules/Landing/instances/areas/glp-app-v2/tirzepatide'
import glpApp from '@/modules/Landing/instances/areas/glp-dm/index'
import glpUsaUniversal from '@/modules/Landing/instances/areas/glp-usa/index'
import glpUsaSemaglutide from '@/modules/Landing/instances/areas/glp-usa/semaglutide'
import glpUsaTirzepatide from '@/modules/Landing/instances/areas/glp-usa/tirzepatide'

// Keys are the landing ids: analytics gets them as the `LANDING_<id>` step and
// `src/funnels/areas/*.ts` refers to them, so they stay put when a file moves.
// `generate-types` builds `LandingId` from these keys. The files follow the Paywall layout,
// `instances/areas/<appArea>/`: `index.ts` for the area's bare URL, `semaglutide.ts` /
// `tirzepatide.ts` for the A1 / B1 overrides, a subfolder per creative.
export const instances = {
	// Loader interstitial on /dm (areas/glp-dm). The id predates that area and stays.
	'glp-app': glpApp,
	// The marketing landing, one full schema per variant. A bare /app gets the
	// universal one; `utm_term` with A1 / B1 picks a compound (DEV-35776, see
	// `src/funnels/areas/glp-app.ts`).
	'glp-app-universal': glpAppUniversal,
	'glp-app-semaglutide': glpAppSemaglutide,
	'glp-app-tirzepatide': glpAppTirzepatide,
	// Same three variants for the ExpertCarter creative, with its own first screen and CTA copy.
	'glp-app-universal-promo': glpAppUniversalPromo,
	'glp-app-semaglutide-promo': glpAppSemaglutidePromo,
	'glp-app-tirzepatide-promo': glpAppTirzepatidePromo,
	// US-themed creatives on /app-usa (DEV-35942, `src/funnels/areas/glp-usa.ts`), the same
	// three variants picked by `utm_term`.
	'glp-usa-universal': glpUsaUniversal,
	'glp-usa-semaglutide': glpUsaSemaglutide,
	'glp-usa-tirzepatide': glpUsaTirzepatide,
	// The redesigned landing on /app-v2 (DEV-35932, `src/funnels/areas/glp-app-v2.ts`), the same
	// three variants picked by `utm_term`; ExpertCarter creatives land on them too.
	'glp-app-v2-universal': glpAppV2Universal,
	'glp-app-v2-semaglutide': glpAppV2Semaglutide,
	'glp-app-v2-tirzepatide': glpAppV2Tirzepatide,
}
